import React, { useState } from "react";

import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import Button from "../../atoms/button/button";
import RichtextDescription from "../../atoms/richtext-description/richtextDescription";

import "./frequent-questions.scss";
interface StoreInterface {
  title: any;
  description: any;
  keyelements: number;
}

const FrequentlyAskedQuestions = (props: ReferenciaContenido) => {
  const [questAnswer, setQuestAnswer] = useState(0);

  const FrequentQuestionInfo = (props: StoreInterface) => {
    const { title, description, keyelements } = props;
    
    return (
      <div className={`m-questions`} key={keyelements}>
        <h3
          className={`m-questions-title ${
            keyelements === questAnswer ? "m-questions-title-show" : ""
          } `}
          onClick={() => changeanswers(keyelements)}
        >
          <span>{title}</span>
          <i
            className={`m-questions-icon ${
              keyelements === questAnswer
                ? "icon-minus-thin"
                : "icon-plus-thin"
            }`}
          />
        </h3>
        <div className={`m-questions-description`}>
          <RichtextDescription {...description} />
        </div>
      </div>
    );
  };

  const changeanswers = (dess: number) => {
    setQuestAnswer(questAnswer === dess ? -1 : dess);
  };

  return (
    <div className="m-frequently">
      <h2 className="m-frequently-title title-secondary">
        {props.tituloGeneral}{" "}
      </h2>

      <div className="m-frequently-questions">
        {props.referenciaPlantillaContenido.map((elem, indexpo) => (
          <FrequentQuestionInfo
            key={indexpo}
            title={elem.tituloBanner}
            description={elem}
            keyelements={indexpo}
          />
        ))}
      </div>
      {props.tituloBoton && (
        <div className="m-frequently-button">
          <Button
            type={"link"}
            classname={`primary`}
            text={props.tituloBoton}
            href={props.redireccionBoton}
            isDisabled={false}
          />
        </div>
      )}
    </div>
  );
};

export default FrequentlyAskedQuestions;
